
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"282","height":"290","viewBox":"0 0 282 290","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M187.5 253.167C62.5 325.5 0 289.333 0 144.667C0 0 62.5 -36.1667 187.5 36.1667C312.5 108.5 312.5 180.833 187.5 253.167Z","fill":"#BAE3FF"}})])
          )
        }
      }
    